<template>
    <div class="transfer" :style="{ width, height }">
        <template>
            <!-- 左侧穿梭框 原料框 -->
            <div class="transfer-left">
                <span class="transfer-title">{{ $t(fromTitle) }}</span>
                <slot name="title-left"></slot>
                <!-- 内容区 -->
                <div class="transfer-main">
                    <td-table
                        ref="from-tree"
                        :columns="columns"
                        :dataSource="self_from_data"
                        :height="tableHeight"
                        :rowKey="rowKey"
                        :selectable="selectable"
                        :hasLoading="hasLoading"
                        @handleSelect="fromTreeChecked"
                        @handleSelectAll="fromAllBoxChange"
                        :hasPage="false"
                        :hasIndex="false"
                    ></td-table>
                    <slot name="left-footer"></slot>
                </div>
            </div>
            <!-- 穿梭区 按钮框 -->
            <div class="transfer-center">
                <template>
                    <p class="transfer-center-item">
                        <el-button type="primary" @click="addToAims" icon="el-icon-arrow-right" circle :disabled="from_disabled"></el-button>
                    </p>
                </template>
            </div>
            <!-- 右侧穿梭框 目标框 -->
            <div class="transfer-right">
                <span class="transfer-title">{{ $t(toTitle) }}</span>
                <slot name="title-right"></slot>
                <!-- 内容区 -->
                <div>
                    <td-tree
                        ref="to-tree"
                        :nodeKey="node_key"
                        :showBox="showbox"
                        :defaultProps="defaultProps"
                        :draggable="draggable"
                        :inputShow="false"
                        :params="params"
                        :calInternal="calInternal"
                        :interfaceName="interfaceName"
                        :lazyloading="lazyloading"
                        :isPaging="isPaging"
                        :height="treeHeight"
                        :dragLevel="dragLevel"
                        :isSingleCheck="isSingleCheck"
                        :checkStrictly="checkStrictly"
                        :expandAll="openAll"
                        :allow-drag="allowDrag"
                        @nodeDrop="nodeDrop"
                    >
                    </td-tree>
                    <slot name="right-footer"></slot>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            from_is_indeterminate: false, // 源数据是否半选
            from_check_all: false, // 源数据是否全选
            to_is_indeterminate: false, // 目标数据是否半选
            to_check_all: false, // 目标数据是否全选
            from_expanded_keys: [], // 源数据展开节点
            to_expanded_keys: [], // 目标数据展开节点
            self_from: [], // 子组件左侧数据
            self_to: [], // 子组件右侧数据
            from_disabled: true, // 添加按钮是否禁用
            to_disabled: true, // 移除按钮是否禁用
            from_check_keys: [], // 源数据选中key数组 以此属性关联穿梭按钮，总全选、半选状态
            to_check_keys: [], // 目标数据选中key数组 以此属性关联穿梭按钮，总全选、半选状态
            showbox: true
        };
    },
    props: {
        params: Object,
        // 是否使用组件内部方法获取树形数据
        calInternal: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        lazyloading: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //节点是否可以选择
        selectable: Function,
        allowDrag: Function,
        // 节点是否只允许同级拖拽
        dragLevel: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 接口地址
        interfaceName: {
            type: Object,
            default: function() {
                return {
                    query: '',
                    search: ''
                };
            }
        },
        isPaging: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 是否遵循父节点选中后子节点也相继选中
        checkStrictly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 宽度
        width: {
            type: String,
            default: '100%'
        },
        rowKey: {
            type: String,
            default: function() {
                return '';
            }
        },
        hasLoading: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        columns: {
            type: Array,
            default: () => []
        },
        // 高度
        height: {
            type: String,
            default: '320px'
        },
        tableHeight: {
            type: Number,
            default: function() {
                return 300;
            }
        },
        treeHeight: {
            type: Number,
            default: function() {
                return window.innerHeight - 500;
            }
        },
        // 标题
        title: {
            type: Array,
            default: () => ['common.SERACH_NEW', 'common.ALREADY_ADD_Route']
        },
        // 穿梭按钮名字
        button_text: Array,
        // 源数据
        from_data: {
            type: Array,
            default: () => []
        },
        // 选中数据
        to_data: {
            type: Array,
            default: () => []
        },
        // el-tree 配置项
        defaultProps: {
            type: Object,
            default: () => {
                return {
                    children: 'children',
                    label: 'label',
                    id: 'sId',
                    imgName: 'imgName',
                    parentId: 'parentId'
                };
            }
        },
        // el-tree node-key 必须唯一
        node_key: {
            type: String,
            default: 'sId'
        },
        devId: {
            type: String,
            default: 'id'
        },
        // 自定义 pid参数名
        pid: {
            type: String,
            default: 'parentId'
        },

        // 是否启用筛选
        filter: {
            type: Boolean,
            default: false
        },
        // 是否展开所有节点
        openAll: {
            type: Boolean,
            default: false
        },

        // 穿梭后是否展开节点
        transferOpenNode: {
            type: Boolean,
            default: true
        },
        // 源数据 默认选中节点
        defaultCheckedKeys: {
            type: Array,
            default: () => []
        },
        // 筛选placeholder
        placeholder: {
            type: String,
            default: ''
        },
        // 默认穿梭一次默认选中数据
        defaultTransfer: {
            type: Boolean,
            default: false
        },

        // 是否开启节点可拖拽
        draggable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 树形节点复选框是否单选
        isSingleCheck: {
            type: Boolean,
            default: function() {
                return true;
            }
        }
    },
    created() {
        this.from_check_keys = this.defaultCheckedKeys;
    },
    methods: {
        // 左侧表单操作
        addToAims() {
            // 获取选中通过穿梭框的keys - 仅用于传送纯净的id数组到父组件同后台通信
            // let keys = this.$refs['from-tree'].getCheckedKeys(this.leafOnly);
            // 获取半选通过穿梭框的keys - 仅用于传送纯净的id数组到父组件同后台通信
            // let harfKeys = this.$refs['from-tree'].getHalfCheckedKeys();
            // 选中节点数据
            let arrayCheckedNodes = this.$refs['from-tree'].getSelectAllRows();

            // 半选中节点数据
            // let arrayHalfCheckedNodes = this.$refs['from-tree'].getHalfCheckedNodes();
            // 左侧树形选中的数据 --- 全选状态
            let arrayHalfCheckedNodes = this.$refs['to-tree'].getCheckedNodes();
            for (let i = 0; i<arrayCheckedNodes.length; i++) {
                if (this.$util.isEmpty(arrayCheckedNodes[i].name)) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_EMPTY_DEVICE_NAME'), type: 'error' });
                    return;
                }
            };
            // 自定义参数读取设置
            let children__ = this.defaultProps.children || 'children';
            let pid__ = this.pid || 'parentId';
            let id__ = this['node_key'] || 'sId';
            let key = this['devId'] || 'id';
            /*
             * 先整合目标树没有父节点的叶子节点选中，需要整理出来此叶子节点的父节点直到根节点路径 - 此时所有骨架节点已有
             * 再将所有末端叶子节点根据pid直接推入目标树即可
             * 声明新盒子将所有半选节点的子节点清除 - 只保留骨架 因为排序是先父后子 因此不存在子元素处理好插入时父元素还没处理的情况
             * 下面一二步是为了搭建出来目标树没有根节点躯干节点时的叶子选中，给此叶子搭建出根节点和躯干节点
             */
            // let不存在状态提升 因此在函数调用之前赋值 并递归为以为数组！
            let self_to_data = JSON.stringify(this.self_to_data);

            if (arrayHalfCheckedNodes !== '' && arrayHalfCheckedNodes.length > 0) {
                let tempVal = arrayHalfCheckedNodes[0];
                if (!tempVal[children__]) {
                    tempVal[children__] = [];
                }
                arrayCheckedNodes.forEach(item => {
                    if (!item[pid__]) {
                        item[pid__] = '';
                    }
                    item[pid__] = arrayHalfCheckedNodes[0][key];
                    if (!inquireIsExist(item)) {
                        item[children__] = [];
                        let val = JSON.parse(JSON.stringify(item));
                        // this.$refs['to-tree'].editTreeNode('', 'add', item);
                        tempVal[children__].push(val);
                    }
                });
            } else {
                // 末端叶子插入目标树
                arrayCheckedNodes.forEach(item => {
                    if (!inquireIsExist(item)) {
                        item[children__] = [];
                        let val = JSON.parse(JSON.stringify(item));
                        this.$refs['to-tree'].editTreeNode([{ parentId: '', id: '' }], 'add', val);
                        this.self_to.push(val);
                    }
                });
            }
            // 递归查询data内是否存在item函数
            function inquireIsExist(item, strData = self_to_data) {
                // 将树形数据格式化成一维字符串 然后通过匹配来判断是否已存在
                let strItem = typeof item[id__] == 'number' ? `"${key}" : ${item[key]},` : `"${key}":"${item[key]}"`;
                let reg = RegExp(strItem);
                let existed = reg.test(strData);
                return existed;
            }
            // 获取选中通过穿梭框的nodes - 仅用于传送选中节点数组到父组件同后台通信需求
            let nodes = JSON.parse(JSON.stringify(arrayCheckedNodes));
            if (arrayCheckedNodes) {
                this.$refs['from-tree'].clearSelection();
            }
            // 处理完毕按钮恢复禁用状态
            this.from_check_keys = [];
            // 传递信息给父组件
            this.$emit('addCallBack', this.self_from_data, this.self_to_data, {
                nodes
            });
            // this.$refs['to-tree'].initTree();
        },

        // 源树选中事件 - 是否禁用穿梭按钮
        fromTreeChecked(nodeObj, treeObj) {
            for (let i=0; i<nodeObj.length; i++) {
                 if (this.$util.isEmpty(nodeObj[i].name)) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_EMPTY_DEVICE_NAME'), type: 'error' });
                    return;
                }
            };
            this.from_check_keys = nodeObj;
            this.$emit('left-check-change', nodeObj, treeObj);
        },

        // 源数据 总全选checkbox
        fromAllBoxChange(val) {
            for (let j=0; j<val.length; j++){
                if (this.$util.isEmpty(val[j].name)) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_EMPTY_DEVICE_NAME'), type: 'error' });
                    return;
                };
            }
            if (this.self_from_data.length == 0) {
                return;
            }
            if (val.length > 0) {
                this.from_check_keys = this.self_from_data;
            } else {
                this.from_check_keys = [];
            }
        },

        // 拖拽完成回调
        nodeDrop(dragNode, dropNode, dropType) {
            this.$emit('nodeDrop', dragNode, dropNode, dropType, this.self_to_data);
        }
    },
    computed: {
        // 左侧数据
        self_from_data() {
            let from_array = [...this.from_data, ...this.self_from];
            return from_array;
        },
        // 右侧数据
        self_to_data() {
            let to_array = [...this.to_data, ...this.self_to];
            return to_array;
        },
        // 左侧菜单名
        fromTitle() {
            let [text] = this.title;
            return text;
        },
        // 右侧菜单名
        toTitle() {
            let [, text] = this.title;
            return text;
        },
        // 右侧菜单名2
        toTitleSecond() {
            let [, , text] = this.title;
            return text;
        },
        // 右侧菜单名3
        toTitleThird() {
            let [, , , text] = this.title;
            return text;
        }
    },
    watch: {
        // 左侧 状态监测
        from_check_keys(val) {
            if (val.length > 0) {
                // 穿梭按钮是否禁用
                this.from_disabled = false;
                // 总半选是否开启
                this.from_is_indeterminate = true;

                // 总全选是否开启 - 根据选中节点中为根节点的数量是否和源数据长度相等
                let allCheck = val.filter(item => item[this.pid] == 0);
                if (allCheck.length == this.self_from_data.length) {
                    // 关闭半选 开启全选
                    this.from_is_indeterminate = false;
                    this.from_check_all = true;
                } else {
                    this.from_is_indeterminate = true;
                    this.from_check_all = false;
                }
            } else {
                this.from_disabled = true;
                this.from_is_indeterminate = false;
                this.from_check_all = false;
            }
        },
        // 右侧 状态监测
        to_check_keys(val) {
            if (val.length > 0) {
                // 穿梭按钮是否禁用
                this.to_disabled = false;
                // 总半选是否开启
                this.to_is_indeterminate = true;

                // 总全选是否开启 - 根据选中节点中为根节点的数量是否和源数据长度相等
                let allCheck = val.filter(item => item[this.pid] == 0);
                if (allCheck.length == this.self_to_data.length) {
                    // 关闭半选 开启全选
                    this.to_is_indeterminate = false;
                    this.to_check_all = true;
                } else {
                    this.to_is_indeterminate = true;
                    this.to_check_all = false;
                }
            } else {
                this.to_disabled = true;
                this.to_is_indeterminate = false;
                this.to_check_all = false;
            }
        },

        // 监视默认选中
        defaultCheckedKeys(val) {
            if (val && eval(this.defaultTransfer)) {
                this.$nextTick(() => {
                    this.addToAims();
                });
            }
        }
    }
};
</script>

<style scoped>
.transfer {
    position: relative;
    overflow: hidden;
}

.transfer-left {
    position: absolute;
    top: 0;
    left: 0;
}

.transfer-right {
    position: absolute;
    top: 0;
    right: 0;
}

.transfer-right-item {
    height: calc(100%);
}

.transfer-right-small {
    height: 41px;
}

.transfer-main {
    padding: 10px;
    height: calc(100%-10px);
    box-sizing: border-box;
    overflow: auto;
}

.transfer-right {
    width: 35%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    vertical-align: middle;
}
.transfer-left {
    width: 55%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    vertical-align: middle;
}

.transfer-center {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20%;
    transform: translateY(-50%);
    text-align: center;
}

.transfer-center-item {
    padding: 10px;
    overflow: hidden;
}
.transfer-center-item {
    height: 50%;
    padding: 70px 10px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.transfer-title {
    border-bottom: 1px;
    padding: 0 15px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
}

.transfer-title .el-checkbox {
    margin-right: 10px;
}

.filter-tree {
    margin-bottom: 10px;
}

.move_up_img {
    float: right;
    margin-top: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.move_down_img {
    transform: rotate(180deg);
}
</style>
